module.exports = __webpack_public_path__ + "img/service.21dd9fa3.png";